export const COUPON_LOCAL_STORAGE_DAYS_AFTER_EXPIRY = 1;
export const NUMBER_OF_DAYS_AFTER_EXPIRY = 14;
export const BATCH_SIZE = 10;